/** 출석 단말(태블릿) 등록 정보. terminal_token은 등록 응답에서만 내려오므로 이 기기 localStorage에만 보관한다. */
export interface StoredAttendanceTerminal {
  academyId: number;
  terminalId: number;
  terminalName: string;
  terminalToken: string;
}

export const ATTENDANCE_TERMINAL_STORAGE_KEY = 'attendanceTerminal';

export function getStoredAttendanceTerminal(): StoredAttendanceTerminal | null {
  try {
    const raw = window.localStorage.getItem(ATTENDANCE_TERMINAL_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAttendanceTerminal;
    return parsed.terminalToken ? parsed : null;
  } catch {
    return null;
  }
}

export function setStoredAttendanceTerminal(terminal: StoredAttendanceTerminal) {
  window.localStorage.setItem(ATTENDANCE_TERMINAL_STORAGE_KEY, JSON.stringify(terminal));
}

export function clearStoredAttendanceTerminal() {
  window.localStorage.removeItem(ATTENDANCE_TERMINAL_STORAGE_KEY);
}
